module.exports = __webpack_public_path__ + "static/media/competency.295772b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/competency.png
// module id = 886
// module chunks = 0